import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class WaterParametersValueModel extends BaseModel {

    constructor() {
        super({
            name: "water_parameters_value",
            tableName: 'water_parameters_value',
            label: "Cài đặt thông số nước",
            display_key: 'name',
            default_order: { key: 'ordinal', direction: 'asc' }
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: {
                name: 'id',
                type: "Uuid",
                label: 'ID',
                primaryKey: true,
                display: false
            },
            water_parameters_id: {
                name: 'water_parameters_id',
                type: "Uuid",
                label: 'ID',
                display: false
            },
            value: {
                name: 'value',
                type: "String",
                class: "center",
                display: false,
            },
            obtain: {
                name: 'obtain',
                type: 'boolean',
                display: false,
            },
            unobtain: {
                name: 'unobtain',
                type: 'boolean',
                display: false,
            },
            ordinal: {
                name: 'ordinal',
                type: "Number",
                displat: false,
            },
            active: {
                name: "active",
                type: "Selection", 
                custom: 'SelectionText',
                label: "Trạng thái",
                class: "center",
                options: [
                    {value : true , label: "Hoạt động"},
                    {value : false , label : "Không hoạt động"}
                ],
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            created_at: {
                name: 'created_at',
                type: "DateTime",
                label: 'Ngày tạo',
                class: "center",
                display: false,
            },
            },
        )
    }

}